module.exports = __webpack_public_path__ + "static/media/MK.0098b523.svg";